<template>
  <base-layout :title="title" :backLink="backLink" :reloadable="reloadable">
    <ion-grid fixed>
      <ion-row>
        <ion-col size="12">
          <ion-list>
            <ion-item class="ion-margin-bottom" lines="none">
              <ion-label position="floating">Select Attendance Date</ion-label>
              <ion-datetime
                type="text"
                v-model="date"
                placeholder="Select Date"
                @ionChange="fetchStudents()"
              ></ion-datetime>
              <ion-button fill="solid" slot="end" @click="confirmSMS">
                Send SMS
              </ion-button>
            </ion-item>
            <ion-item>
              <ion-label class="ion-text-wrap">
                <h2>Preview</h2>
                <p>
                  "Respected parents, your child {#var#} was absent on
                  {{ date_f }}. Kindly contact Principal"
                </p>
              </ion-label>
            </ion-item>
          </ion-list>
        </ion-col>
        <ion-col size="12" v-if="classrooms">
          <ion-item lines="none">
            <h5>
              Select Recipients (Selected: {{ selected_recipients.length }})
            </h5>
          </ion-item>
          <ion-item lines="none">
            <ion-label>Select everyone</ion-label>
            <ion-checkbox
              slot="end"
              style="margin-bottom: 0; margin-top: 0"
              @ionChange="toggleAll($event)"
            ></ion-checkbox>
          </ion-item>
          <ion-item lines="none">
            <h6>Attendances not taken: {{ attendancesNotTaken() }}</h6>
          </ion-item>

          <ion-card v-for="item of classrooms" :key="item.id">
            <ion-card-header>
              <ion-card-title
                >Class {{ item.standard.name }} - {{ item.section.name }}
                <span v-if="user_ids[item.id]"
                  >({{
                    user_ids[item.id].length + "/" + item.students.length
                  }})</span
                >
              </ion-card-title>
              <ion-item lines="none">
                <ion-label>Select entire class</ion-label>
                <ion-checkbox
                  class="select-all-in-class"
                  :value="item.id"
                  slot="end"
                  style="margin-bottom: 0; margin-top: 0"
                  @ionChange="toggleSelectAll(item, $event)"
                ></ion-checkbox>
              </ion-item>
            </ion-card-header>
            <ion-card-content>
              <h5>Atendance not taken: {{ attendances_not_taken[item.id] }}</h5>
              <ion-item>
                <ion-label position="floating">Students</ion-label>
                <ion-select
                  multiple
                  :interface-options="{ cssClass: 'full-screen' }"
                  v-model="user_ids[item.id]"
                  :value="getValues(item.students)"
                  :disabled="disable_student_selection"
                >
                  <ion-select-option
                    v-for="student of item.students"
                    :key="student.id"
                    :value="student.user_id"
                  >
                    {{ `${student.user.user_detail.name}` }}
                  </ion-select-option>
                </ion-select>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </base-layout>
</template>

<script>
import BaseLayout from "../../../Base/BaseLayout.vue";
import {
  IonGrid,
  IonRow,
  IonCol,
  IonList,
  IonItem,
  IonLabel,
  IonDatetime,
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCheckbox,
  IonCardContent,
  IonSelect,
  IonSelectOption,
  loadingController,
  alertController,
  toastController,
} from "@ionic/vue";

import moment from "moment";

export default {
  components: {
    BaseLayout,
    IonGrid,
    IonRow,
    IonCol,
    IonList,
    IonItem,
    IonLabel,
    IonDatetime,
    IonButton,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCheckbox,
    IonCardContent,
    IonSelect,
    IonSelectOption,
  },
  data() {
    return {
      title: "Send Absentee SMS",
      backLink: "sms.template",
      reloadable: false,

      date: new Date().toISOString(),

      user_ids: {},

      attendances_not_taken: {},

      disable_student_selection: true,

      xhrError: {
        header: null,
        description: null,
      },
    };
  },

  computed: {
    date_f() {
      return moment(this.date).format("dddd, MMMM Do YYYY");
    },

    classrooms() {
      return this.$store.getters["absenteeSMS/allResources"];
    },

    selected_recipients() {
      let user_ids = [];
      for (let key in this.user_ids) {
        this.user_ids[key].forEach((element) => {
          user_ids.push(element);
        });
      }
      return user_ids;
    },
  },

  created() {
    this.fetchStudents();
  },

  methods: {
    getValues(students) {
      let values = [];
      for (let key in students) {
        if (students[key].user.attendances.length > 0) {
          if (students[key].user.attendances[0].attendance_state_id == 3) {
            values.push(students[key].user_id);
          }
        }
      }

      return values;
    },

    async toggleSelectAll(item, event) {
      let values = [];

      if (event.detail.checked) {
        for (let key in item.students) {
          values.push(item.students[key].user_id);
        }
      }

      this.user_ids[item.id] = values;
    },

    async toggleAll(event) {
      const toggles = document.querySelectorAll(".select-all-in-class");
      if (event.detail.checked) {
        for (let i = 0; i < toggles.length; i++) {
          toggles[i].checked = true;
        }
      } else {
        for (let i = 0; i < toggles.length; i++) {
          toggles[i].checked = false;
        }
      }
    },

    attendancesNotTaken() {
      let count = 0;
      for (let key in this.attendances_not_taken) {
        count += this.attendances_not_taken[key];
      }

      return count;
    },

    loader(message) {
      const loading = loadingController.create({
        message: message,
        backdropDismiss: false,
      });

      return loading;
    },

    alerter(header, message, buttons = ["close"]) {
      const alert = alertController.create({
        header: header,
        message: message,
        buttons: buttons,
      });

      return alert;
    },

    toaster(message) {
      const toast = toastController.create({
        message,
        duration: 3000,
        color: "primary",
      });

      return toast;
    },

    async confirmSMS() {
      const count = this.selected_recipients.length;
      const header = `Confirm`;
      const message = `Are you sure you want to send ${count} SMS(s)?`;
      const buttons = [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
        },
        {
          text: "Confirm",
          handler: () => {
            this.sendSMS();
          },
        },
      ];
      const alertDialog = await this.alerter(header, message, buttons);

      alertDialog.present();
    },

    async sendSMS() {
      let data = {
        attendance_date: this.date_f,
        user_ids: this.selected_recipients,
      };
      const spinner = await this.loader("Sending...");
      spinner.present();

      try {
        await this.$store.dispatch("absenteeSMS/sendSMS", data);
        spinner.dismiss();
        const toast = await this.toaster("SMS request queued");
        await toast.present();
        this.$router.replace({ name: "communication" });
      } catch (error) {
        spinner.dismiss();
        this.setErrorResponse(error);
        const alertDialog = await this.alerter(
          this.xhrError.header,
          this.xhrError.message
        );
        alertDialog.present();
      }
    },

    async selectAbsentStudents() {
      this.classrooms.forEach((classroom) => {
        this.user_ids[classroom.id] = [];
        let absenteeCount = 0;
        classroom.students.forEach((student) => {
          if (student.user.attendances.length > 0) {
            if (student.user.attendances[0].attendance_state_id == 3) {
              this.user_ids[classroom.id].push(student.user_id);
            }
            if (student.user.attendances[0].attendance_state_id == 1) {
              absenteeCount++;
            }
          } else {
            absenteeCount++;
          }
        });
        this.attendances_not_taken[classroom.id] = absenteeCount;
      });
    },

    async fetchStudents() {
      this.disable_student_selection = true;
      let date = moment(this.date).format("YYYY-MM-DD");
      await this.$store.dispatch("absenteeSMS/allResources", date);
      await this.selectAbsentStudents();
      this.disable_student_selection = false;
    },
  },
};
</script>

<style scoped></style>
